// @core/api/endpoints/task/get_task_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskStatsResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task statistics
 * Returns aggregate statistics for tasks in the product including counts by status, average resolution time, and workload distribution.
 */
export async function GetTaskStats(
  params?: {
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<TaskStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-stats`;
  const requestOptions = options;
  return client.get<TaskStatsResponse>(requestPath, { ...requestOptions, params });
}
